import React, { Component } from 'react';
import { Row, Col, Input, Table, FormGroup } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';

class CustomerListing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            sheetData: [],
            team: this.props.selector != null ? this.props.selector : 0
        };

        this.headers = ['Company Name', 'Contact #1', 'Phone', 'Email', 'Contact #2', 'Phone', 'Email', 'CSSI Team', 'Account Owner', 'Processor', 'Backup',
            'Portfolio Management System', 'System Expiration Date', 'Trading System', 'Data Feed Source', 'Reference Data Source',
            'Recurring Client Call Frequency', 'Last Recurring Client Call', 'Customer Connectivity Method'];
    }

    componentDidMount() {
        this.props.log('CustomerListing.js/componentDidMount');
        this.onSubmit();
    }

    onSubmit = () => {
        this.props.log('CustomerListing.js/onSubmit');
        fetch('/api/reports/CustomerListing', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify([
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        data: results.data.map(row => {
                            return {
                                ...row,
                                team: row.team != null ? row.team[0].teamName : null
                            }
                        })
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getCSVdata = () => {
        this.props.log('CustomerListing.js/getCSVdata');
        const retArr = [[]]
        this.headers.forEach(header => {
            retArr[0].push(header);
        });
        this.state.data.filter(item =>
            (parseInt(this.state.team) > 0 && parseInt(item.team) === parseInt(this.state.team)) ||
            (parseInt(this.state.team) === -1 && item.team == null) ||
            (parseInt(this.state.team) === 0 && parseInt(item.team) !== -1)
        ).forEach(item => {
            let itemArr = [];
            if (item.contacts != null && item.contacts.length > 0) item.contacts = item.contacts.filter(contact => contact.inactive == null || contact.inactive === false);
            itemArr.push(item.name != null ? item.name : '');
            itemArr.push(item.contacts != null && item.contacts[0] != null ?
                ((item.contacts[0].firstName != null ? item.contacts[0].firstName : '') + ' ' +
                    (item.contacts[0].lastName != null ? item.contacts[0].lastName : '')) : '');
            itemArr.push(item.contacts != null && item.contacts[0] != null ?
                item.contacts[0].phone != null ? item.contacts[0].phone : '' : '');
            itemArr.push(item.contacts != null && item.contacts[0] != null ?
                item.contacts[0].email != null ? item.contacts[0].email : '' : '');
            itemArr.push(item.contacts != null && item.contacts[1] != null ?
                ((item.contacts[1].firstName != null ? item.contacts[1].firstName : '') + ' ' +
                    (item.contacts[1].lastName != null ? item.contacts[1].lastName : '')) : '')
            itemArr.push(item.contacts != null && item.contacts[1] != null ?
                item.contacts[1].phone != null ? item.contacts[1].phone : '' : '');
            itemArr.push(item.contacts != null && item.contacts[1] != null ?
                item.contacts[1].email != null ? item.contacts[1].email : '' : '');
            itemArr.push(item.team != null ? item.team : '');
            itemArr.push(item.primary != null && item.primary[0] != null ?
                ((item.primary[0].primaryFirstName != null ? item.primary[0].primaryFirstName : '') + ' ' +
                    (item.primary[0].primaryLastName != null ? item.primary[0].primaryLastName : '')) : '')
            itemArr.push(item.processor != null && item.processor[0] != null ?
                ((item.processor[0].processorFirstName != null ? item.processor[0].processorFirstName : '') + ' ' +
                    (item.processor[0].processorLastName != null ? item.processor[0].processorLastName : '')) : '')
            itemArr.push(item.secondary != null && item.secondary[0] != null ?
                ((item.secondary[0].secondaryFirstName != null ? item.secondary[0].secondaryFirstName : '') + ' ' +
                    (item.secondary[0].secondaryLastName != null ? item.secondary[0].secondaryLastName : '')) : '')
            itemArr.push(item.customerDetails != null && item.customerDetails.portfolioManagementSystem != null ?
                item.customerDetails.portfolioManagementSystem : '');
            itemArr.push(item.customerDetails != null && item.customerDetails.systemExpirationDate != null ?
                this.formatDate(item.customerDetails.systemExpirationDate) : '');
            itemArr.push(item.customerDetails != null && item.customerDetails.tradingSystem != null ?
                item.customerDetails.tradingSystem : '')
            itemArr.push(item.customerDetails != null && item.customerDetails.dataFeedSource != null ?
                item.customerDetails.dataFeedSource : '')
            itemArr.push(item.customerDetails != null && item.customerDetails.referenceDataSource != null ?
                item.customerDetails.referenceDataSource : '')
            itemArr.push(item.customerDetails != null && item.customerDetails.recurringClientCallFrequency != null ?
                item.customerDetails.recurringClientCallFrequency : '')
            itemArr.push(item.customerDetails != null && item.customerDetails.lastRecurringClientCall != null ?
                this.formatDate(item.customerDetails.lastRecurringClientCall) : '')
            itemArr.push(item.customerDetails != null && item.customerDetails.customerConnectivityMethod != null ?
                item.customerDetails.customerConnectivityMethod : '')
            retArr.push(itemArr);
        })
        this.props.passData(retArr, "customer-listing");
    }

    formatDate = (d) => {
        if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
    }

    render() {
        this.props.info('CustomerListing.js/render');
        return (
            <>
                <Row>
                    <Col md={4}>
                        <FormGroup><Input type="select"
                            value={this.props.isFieldNull(this.state.team)}
                            onChange={(e) => this.setState({ team: e.target.value }, () => { this.getCSVdata(); this.props.changeSelector(e); })}
                        >
                            <option value="0">SELECT TEAM</option>
                            {[...new Set([...this.state.data].map(item => item.team))].sort().map((team, teamIndex) => (
                                <option key={"customerListing_" + teamIndex} value={team != null ? (team) : -1}>{team != null ? team : 'Team not set'}</option>
                            ))}
                        </Input></FormGroup>
                    </Col>
                </Row>
                <Table>
                    <thead>
                        <tr>
                            {this.headers.map((header, headerIndex) => (
                                <th key={headerIndex}>{header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.data.filter(item =>
                            (this.state.team != null && this.state.team !== '' && (item.team) === (this.state.team)) ||
                            (parseInt(this.state.team) === -1 && item.team == null) ||
                            (parseInt(this.state.team) === 0 && parseInt(item.team) !== -1)
                        ).map((item, itemIndex) => {
                            if (item.contacts != null && item.contacts.length > 0) item.contacts = item.contacts.filter(contact => contact.inactive == null || contact.inactive === false);
                            return (
                                <tr key={itemIndex}>
                                    <td>{item.name != null ? item.name : ''}</td>
                                    <td>{item.contacts != null && item.contacts[0] != null ?
                                        <>{item.contacts[0].firstName != null ? item.contacts[0].firstName : ''}&nbsp;
                                            {item.contacts[0].lastName != null ? item.contacts[0].lastName : ''}</> : <></>}</td>
                                    <td>{item.contacts != null && item.contacts[0] != null ?
                                        <>{item.contacts[0].phone != null ? item.contacts[0].phone : ''}</> : <></>}</td>
                                    <td>{item.contacts != null && item.contacts[0] != null ?
                                        <>{item.contacts[0].email != null ? item.contacts[0].email : ''}</> : <></>}</td>
                                    <td>{item.contacts != null && item.contacts[1] != null ?
                                        <>{item.contacts[1].firstName != null ? item.contacts[1].firstName : ''}&nbsp;
                                            {item.contacts[1].lastName != null ? item.contacts[1].lastName : ''}</> : <></>}</td>
                                    <td>{item.contacts != null && item.contacts[1] != null ?
                                        <>{item.contacts[1].phone != null ? item.contacts[1].phone : ''}</> : <></>}</td>
                                    <td>{item.contacts != null && item.contacts[1] != null ?
                                        <>{item.contacts[1].email != null ? item.contacts[1].email : ''}</> : <></>}</td>
                                    <td>{item.team != null ? item.team : ''}</td>
                                    <td>{item.primary != null && item.primary[0] != null ?
                                        <>{item.primary[0].primaryFirstName != null ? item.primary[0].primaryFirstName : ''}&nbsp;
                                            {item.primary[0].primaryLastName != null ? item.primary[0].primaryLastName : ''}</> : <></>}</td>
                                    <td>{item.processor != null && item.processor[0] != null ?
                                        <>{item.processor[0].processorFirstName != null ? item.processor[0].processorFirstName : ''}&nbsp;
                                            {item.processor[0].processorLastName != null ? item.processor[0].processorLastName : ''}</> : <></>}</td>
                                    <td>{item.secondary != null && item.secondary[0] != null ?
                                        <>{item.secondary[0].secondaryFirstName != null ? item.secondary[0].secondaryFirstName : ''}&nbsp;
                                            {item.secondary[0].secondaryLastName != null ? item.secondary[0].secondaryLastName : ''}</> : <></>}</td>
                                    <td>{item.customerDetails != null && item.customerDetails.portfolioManagementSystem != null ?
                                        item.customerDetails.portfolioManagementSystem : ''}</td>
                                    <td>{item.customerDetails != null && item.customerDetails.systemExpirationDate != null ?
                                        this.formatDate(item.customerDetails.systemExpirationDate) : ''}</td>
                                    <td>{item.customerDetails != null && item.customerDetails.tradingSystem != null ?
                                        item.customerDetails.tradingSystem : ''}</td>
                                    <td>{item.customerDetails != null && item.customerDetails.dataFeedSource != null ?
                                        item.customerDetails.dataFeedSource : ''}</td>
                                    <td>{item.customerDetails != null && item.customerDetails.referenceDataSource != null ?
                                        item.customerDetails.referenceDataSource : ''}</td>
                                    <td>{item.customerDetails != null && item.customerDetails.recurringClientCallFrequency != null ?
                                        item.customerDetails.recurringClientCallFrequency : ''}</td>
                                    <td>{item.customerDetails != null && item.customerDetails.lastRecurringClientCall != null ?
                                        this.formatDate(item.customerDetails.lastRecurringClientCall) : ''}</td>
                                    <td>{item.customerDetails != null && item.customerDetails.customerConnectivityMethod != null ?
                                        item.customerDetails.customerConnectivityMethod : ''}</td>
                                </tr>
                            )
                        }
                        )}
                    </tbody>
                </Table>
            </>
        );

    }
}

export default CustomerListing;
